import { FC } from 'react';

import {
  Button,
  SpaceBetween,
  FormField,
  Input,
  Form,
  Flashbar,
  Checkbox
} from '@awsui/components-react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { FlashbarProps } from '@awsui/components-react';
import { IUpdateApprovedDomain } from '../../../../../interfaces/authentication/approvedDomain';
interface ViewProps {
  formValues: IUpdateApprovedDomain;
  flashBarItems: FlashbarProps.MessageDefinition[];
  handleSubmittedForm: (data: IUpdateApprovedDomain) => Promise<void>;
}

const View: FC<ViewProps> = ({
  formValues,
  flashBarItems,
  handleSubmittedForm
}) => {
  const validationSchema = yup.object({
    emailDomain: yup
      .string()
      .matches(
        /^([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]+$/,
        'Must be a valid email domain!'
      )
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={true}
        initialValues={formValues}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          handleSubmittedForm(data).then((resp) => {
            resetForm();
            setSubmitting(false);
          });
        }}
      >
        {({ values, errors, isSubmitting, setFieldValue, handleSubmit }) => (
          <SpaceBetween direction="vertical" size="xs">
            <Flashbar items={flashBarItems} />
            <Form
              actions={
                <SpaceBetween direction="horizontal" size="xs">
                  <Button
                    variant="primary"
                    onClick={() => handleSubmit()}
                    disabled={isSubmitting}
                  >
                    Submit
                  </Button>
                </SpaceBetween>
              }
            >
              <FormField label="Domain Name" errorText={errors.domainName}>
                <Input
                  name="domainName"
                  value={values.domainName}
                  onChange={({ detail }) =>
                    setFieldValue('domainName', detail.value)
                  }
                  invalid={!!errors.domainName}
                />
              </FormField>

              <FormField>
                <Checkbox
                  name="deprecated"
                  checked={values.deprecated === 1}
                  onChange={({ detail }) =>
                    setFieldValue('deprecated', detail.checked ? 1 : 0)
                  }
                >
                  Deprecated
                </Checkbox>
              </FormField>
            </Form>
          </SpaceBetween>
        )}
      </Formik>
    </>
  );
};
export default View;
